module.exports = __webpack_public_path__ + "assets/img/bill_coghlan.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bill_coghlan.jpg
// module id = 1919
// module chunks = 0